module.exports = __webpack_public_path__ + "img/aircon.301d6f4c.svg";